import { Resource } from "dtos/stage.dto";

export const taskUi = {
  indigo: "#4f46e5",
  indigoSoft: "#eef2ff",
  indigoLine: "#dad4f6",

  purple: "#a855f7",
  purpleSoft: "#faf5ff",
  purpleLine: "#e9d5ff",

  surface: "#ffffff",
  subtle: "#fafafc",
  hairline: "#f3f3f6",
  border: "#e5e7eb",
  layout: "#f6f6f9",
  text: "#1b1b20",
  textMuted: "#55555f",
  textFaint: "#8a8a96",
  rowHeight: 44,
  subRowHeight: 40,
  groupHeaderHeight: 38,
  radius: 10,
} as const;

export type Tokens = {
  margin: number;
  fontSize: number;
  fontWeight: number;
  lineHeight: string;
  color: string;
  background: string;
  borderColor: string;
};

export const neutralTag = {
  margin: 0,
  fontSize: 11.5,
  fontWeight: 500,
  lineHeight: "18px",
  color: taskUi.textMuted,
  background: "#f3f4f6",
  borderColor: taskUi.border,
} as const;

export const accentTag = {
  ...neutralTag,
  color: taskUi.indigo,
  background: taskUi.indigoSoft,
  borderColor: taskUi.indigoLine,
} as const;

export const RESOURCE_META: Record<Resource, { label: string; dot: string }> = {
  [Resource.APPLICATION]: { label: "Application", dot: taskUi.indigo },
  [Resource.LOAN]: { label: "Loan", dot: "#0d9488" },
};
